import { $GQL } from '@GQL';
import type { Ad } from '@nextgenleads/marketplace-driver';

export async function postDailyAMStats(user_id: string, stats_message: string) {
	const mutation = `
        mutation PostDailyAMStats($user_id: ID!, $stats_message: String!) {
            postDailyAMStats(account_manager_id: $user_id, stats_message: $stats_message)
        }
    `;
	const result = await $GQL.request(mutation, { user_id, stats_message });
	return result.postDailyAMStats;
}
